<template>
    <div>        

        <!-- TopNav default -->        
        <v-app-bar
          fixed
          class="topnav"
          v-if="template=='default'"
          >

          <v-btn class="logo" :to="{ name: 'Home'}" text style="margin-right:20px;">
            <img :src="'/'+$home+'graf/thwi_logo.png'" width="80">
          </v-btn>

           <v-toolbar-title>
            <router-link :to="{ name: 'Home'}" style="font-size:inherit;color:inherit;">
              {{ $t('title_transfer_plattform')}}
            </router-link>
            </v-toolbar-title> 

          <v-spacer></v-spacer>

          <v-spacer></v-spacer>

          <div>
            
            <div class="pt-1">

                <v-menu v-if="screenWidth && screenWidth < 1000">
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on" depressed small class="ml-2">
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item>
                      <router-link :to="{ name: 'Suche'} " class="mt-2 mx-6 mainitem">
                        {{ $t('Home') }}
                      </router-link>
                    </v-list-item>
                    <v-list-item>
                      <router-link :to="{ name: 'Imprint'} " class="mt-3 mx-6 mainitem">
                        {{ $t('imprint') }}
                      </router-link>
                    </v-list-item>
                    <v-list-item>
                      <router-link :to="{ name: 'Privacy'} " class="mt-3 mx-6 mainitem">
                        {{ $t('privacy') }}
                      </router-link>
                    </v-list-item>
                  </v-list>
                </v-menu>

                <div v-else style="display:inline;">

                  <router-link :to="{ name: 'Suche'} " class="mt-2 mx-6 mainitem">
                      {{ $t('Home') }}
                  </router-link>

                  <router-link :to="{ name: 'Imprint'} " class="mt-3 mx-6 mainitem">
                      {{ $t('imprint') }}
                  </router-link>

                  <router-link :to="{ name: 'Privacy'} " class="mt-3 mx-6 mainitem">
                      {{ $t('privacy') }}
                  </router-link>                

                </div>

                <!-- Sprachwechsel
                  <select v-model="$i18n.locale">
                    <option v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang.code">
                      {{ lang.text }}
                    </option>
                  </select>
                -->

                <router-link v-if="user.name" :to="'/'+$home+'admin'" class="ml-4 mr-4">
                    <v-icon>mdi-cog</v-icon>
                </router-link>

                <v-menu          
                  offset-y
                  offset-x
                  v-if="user.name"            
                >
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on" depressed small class="ml-2">
                      <v-icon>mdi-account</v-icon>
                    </v-btn>
                  </template>

                  <v-list>
                    <v-list-item>
                      <router-link :to="{ name: 'Login' }">
                        <v-list-item-title>Profil</v-list-item-title>
                      </router-link>
                    </v-list-item>
                    <v-list-item>
                      <router-link :to="{ name: 'Login' }">
                        <v-list-item-title>Logout</v-list-item-title>
                      </router-link>
                    </v-list-item>
                  </v-list>
                </v-menu>          

                <router-link :to="{ name: 'Login'} " class="mt-2 mx-6" v-else>                
                    <v-icon size="16"
                    class="lockbutton"
                    style="margin-top:-2px"
                    >mdi-lock</v-icon>
                </router-link>

            </div>

          </div>

        </v-app-bar>

    </div>
</template>

<script>
//import { log } from 'three';
import { eventBus } from '../main.js';
import vuetify from '@/plugins/vuetify';
// import UsecaseExit from './controls/UsecaseExit.vue';

export default {
  props: {
    drawer: Object,
    template: String,
    controls: Object
  },
  components: {
    // UsecaseExit
  },
  data(){
    return {
      host: window.location.host,
      items: [
        { title: 'Stage', icon: 'mdi-home-city', link: 'Stage' },
        { title: 'Admin', icon: 'mdi-account-tie', link: 'Admin' },
        { title: 'Users', icon: 'mdi-account-tie', link: 'List' },
        { title: 'Categories', icon: 'mdi-account-tie', link: 'Layout' }
      ],
      testfields: [
        { title: 'NAO-Leseroboter', icon: '', link: 'Stage' },
        { title: 'NLP', icon: '', link: 'NLP' },
        { title: 'Digitale Bibliothek', icon: '', link: 'SpaceBib' },

      ],
      admindrawer: null,
      //user: this.$store.getters.userdata     
      langs: [
        { code: "en", text: "EN" },
        { code: "de", text: "DE" },
      ] 
    }
  },
  methods:{
      changeDrawer() {
          this.drawer.visible = !this.drawer.visible;
      },
      fetchTemplate() {
          //console.log("Fetch Template in TopNav:");
          //console.log(this.template);
      },
      toggleMenu() {
          this.controls.visible = !this.controls.visible;
          //console.log("topnav");
          eventBus.$emit('controls-visible', this.controls.visible);          
      }      
  },
  computed:{
      user () {
        return this.$store.getters.userdata
      },
      node: {
        get() {
          return this.$store.getters.node
        },
        set(val) {
          return val
        }        
      },
      panoActive () {
        return this.$route.path.indexOf('/panorama') !== -1 ||
          this.$route.path.indexOf('/pn/') !== -1
      },
      screenWidth() {
        return vuetify.framework.breakpoint.width;
      }
  },
  watch: {
      user: function (values) {          
          this.node = values;          
      }
  },
  mounted() {
    this.fetchTemplate();
    // console.log('vuetify display:');
    // console.log(vuetify.framework.breakpoint.width);
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.logo {
  margin-right:2px;
}
.logo.v-btn--active {
  color:#ffffff;
}
.theme--light.v-app-bar.v-toolbar.v-sheet {
  background-color:#fff;
}
.v-icon,
.v-btn .v-icon {
  color:#0076bc;
}

.v-icon.lockbutton {
  color:#999;
}

a.mainitem:hover,
a.mainitem.router-link-active,
a.active,
a.mainitem:hover .v-icon,
a.mainitem.router-link-active .v-icon,
a.active .v-icon {  
  color:orange;
}


/* icampus template */
.titleplus {
  color:#0d60b2;
  padding:4px 10px;
  font-weight:bold !important;
  font-size:1rem;
  background-image: linear-gradient(to right, #f49e30, #ed7724);
}
.topnav.icampus {
  background-color:transparent;
  color:#ffffff !important;
  background-image: linear-gradient(to bottom, #042f7e, #0d64ac);
}
.icampus .v-icon,
.icampus .v-btn .v-icon {
  color:#ffffff !important;
}

</style>
